import React from "react";
import BridalGrid from "../Components/BridalGrid/BridalGrid";

const BridalPage = () => {
  return <BridalGrid />;
};

export default BridalPage;
